import React from "react";
import image from "../../UTILS/Profile Icon.png";
// const image=new URL("menjacket.jpg",import.meta.url)
function Profile() {
  return (
    <div className="profile-sec">
      <div class="linee">
        <a class="dot" href="">
          ...
        </a>{" "}
      </div>
      <center>
        <input
          type="image"
          class="profile-image"
          width="240px"
          height="240.04"
          src={image}
          name="profile-image"
          id="profile-image"
        />
        <br></br>
        
      </center>

      <div className="overflow">
        <form>
          <label for="firstName" className="pro-label">
            First Name
          </label>
          <br></br>
          <input
            type="text "
            required="true"
            class="profile-info"
            size="55"
            name="firstName"
            id="companyName"
            maxlength="20"
            placeholder="First Name"
          />
          <br></br>
          <label for="lastname" className="pro-label">
            Last Name
          </label>
          <br></br>

          <input
            type="text "
            required="true"
            class="profile-info"
            name="lastname"
            size="55"
            id="lastname"
            placeholder="Last Name"
          />
          <br></br>
          <label for="companyName" className="pro-label">
            Company Name
          </label>
          <br></br>
          <input
            type="text"
            raquired="true"
            class="profile-info"
            name="companyName"
            size="55"
            id="companyName"
            placeholder="Company Name"
          />
          <br></br>
          <label className="pro-label">E-mail address</label>
          <br></br>
          <input
            type="email"
            required="true"
            class="profile-info"
            placeholder="mo*******@gmail.com"
            name="email"
            size="55"
            id="email"
          />
          <br></br>
          <label for="phone" className="pro-label">
            Phone Number
          </label>
          <br></br>
          <input
            type="tel"
            required="true"
            class="profile-info"
            placeholder="+91-988*******"
            name="phone"
            size="55"
            id="phone"
          />
          <br></br>
        </form>
      </div>
      <center>
        {" "}
        <button type="submit" class="btn">
          Save
        </button>
        <br></br>
        <p
          class="data"
          style={{
            color: "#7E7E7E",
            marginBottom:'20px'
          }}
        >
          Your data will be updated on directory ASAP
        </p>
      </center>
      <div class="line2">
        <p className="acc">Account details</p>
      </div>
    </div>
  );
}
export default Profile;
